import { FC, memo, useCallback } from 'react';
import { UserPicker } from 'shared/components';

import { useOffboardingContext } from '../../OffboardingContext';
import { GLOBAL_USER_REPLACEMENT } from '../../OffboardUserPopupContent.types';
import { ReplacementCellProps } from './ReplacementCell.types';

const ReplacementCell: FC<ReplacementCellProps> = memo((props) => {
    const { item, invalid } = props;

    const { showErrors, teamWithoutOnboarded, selectReplacement, selectedReplacements } = useOffboardingContext();

    const selectedReplacementId = item ? item.id : GLOBAL_USER_REPLACEMENT;

    const isInvalid = invalid || (item?.required && showErrors && !selectedReplacements[item.id]);

    const onSelectReplacement = useCallback(
        (id: string) => {
            const user = teamWithoutOnboarded.find((user) => user.id === id);

            selectReplacement(selectedReplacementId, user ? user : null);
        },
        [selectReplacement, selectedReplacementId, teamWithoutOnboarded]
    );

    return (
        <UserPicker
            users={teamWithoutOnboarded}
            value={selectedReplacements[selectedReplacementId]?.id}
            onChange={onSelectReplacement}
            invalid={isInvalid}
        />
    );
});

export default ReplacementCell;
